import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import {
    AlertContextProvider,
    LoaderContextProvider,
    ProfileContextProvider
} from './contexts';
import DialogContextWithError from './contexts/DialogContextWithError';
import { ThemeProvider } from '@emotion/react';
import { vdsMuiTheme } from './@vds';

declare global {
    interface Window {
        FrontendSettings: {
            ACCESS_RETRY_TIMEOUT: number;
        };
    }
}

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

root.render(
    <ThemeProvider theme={vdsMuiTheme}>
        <LoaderContextProvider>
            <AlertContextProvider>
                <DialogContextWithError>
                    <BrowserRouter>
                        <ProfileContextProvider>
                            <App />
                        </ProfileContextProvider>
                    </BrowserRouter>
                </DialogContextWithError>
            </AlertContextProvider>
        </LoaderContextProvider>
    </ThemeProvider>
);
